import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { PlatformService } from '../../../../../../core/services/platform.service';
import { ILandingPostCommentActivityPublic } from '../../../interface';
import { LandingPageDataService } from '../../../services/landing-post-data.service';
import { LandingPostService } from '../../../services/landing-post.service';
import { AuthGuardService } from '../../../../../../core/services/auth/auth-guard.service';
import { first } from 'rxjs';

@Component({
  selector: 'app-comment-details',
  templateUrl: './comment-details.component.html',
  styleUrl: './comment-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class CommentDetailsComponent {
  @Input() comment!: ILandingPostCommentActivityPublic;

  constructor(
    private landingPostService: LandingPostService,
    public landingPageDataService: LandingPageDataService,
    private authGuardService: AuthGuardService,
    private cdr: ChangeDetectorRef,
  ) { }

  async like() {
    if (!this.authGuardService.isLoggedIn()) {
      var loginModalId = this.authGuardService.openLoginModalRequest();
      this.authGuardService.onLoginFromModel.pipe(first()).subscribe(loginrefId => {
        if (loginModalId == loginrefId)
          this.like();
      })
      return;
    }

    var res = await this.landingPostService.likeComment(
      this.landingPageDataService.details()._id,
      this.comment._id,
      this.landingPageDataService.isQrCode(),
    );

    this.comment = { ...this.comment, ...res.result };
    this.cdr.detectChanges();
  }

  async dislike() {
    if (!this.authGuardService.isLoggedIn()) {
      var loginModalId = this.authGuardService.openLoginModalRequest();
      this.authGuardService.onLoginFromModel.pipe(first()).subscribe(loginrefId => {
        if (loginModalId == loginrefId)
          this.dislike();
      })
      return;
    }

    var res = await this.landingPostService.dislikeComment(
      this.landingPageDataService.details()._id,
      this.comment._id,
      this.landingPageDataService.isQrCode(),
    );

    this.comment = { ...this.comment, ...res.result };
    this.cdr.detectChanges();
  }
}
